<template>
  <dashboard-card class="db-gloss-insurance" title="Glosas por convênio"
                  note="% sobre o valor faturado">
    <div class="loading loading-lg db-card-loading" v-if="loading"></div>

    <dashboard-empty
      v-else-if="rows.length === 0"
      icon="shield-check"
      title="Nenhuma glosa por convênio"
      reason="Nenhum convênio devolveu glosa no período. O índice aparece aqui assim que um
              demonstrativo for lançado."
      action-to="/financial/billing-glosses"
      action-label="Ir para Glosas e recursos"
      action-icon="gavel"
    />

    <div class="db-list" v-else>
      <router-link class="db-list-row db-list-link" v-for="row in rows" :key="row.key"
                   :to="row.to">
        <div>
          <div class="db-list-name" :title="row.insuranceName">{{ row.insuranceName }}</div>
          <div class="db-list-sub">Faturado {{ row.informed | currency }}</div>
        </div>
        <div>
          <div class="db-list-value db-error-text">{{ row.percentLabel }}</div>
          <div class="db-list-percent">{{ row.glossed | currency }} glosado</div>
        </div>
        <div class="db-bar" :class="{'db-bar-strong': row.critical}">
          <span :style="{ width: row.width }"></span>
        </div>
      </router-link>
    </div>
  </dashboard-card>
</template>

<script>
import { formatPercent, glossInsuranceRoute } from '../helpers';
import DashboardCard from './DashboardCard.vue';
import DashboardEmpty from './DashboardEmpty.vue';

const CRITICAL_PERCENT = 10;

export default {
  components: {
    DashboardCard,
    DashboardEmpty,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rows() {
      return this.items.map((item, index) => ({
        ...item,
        key: item.insuranceId || `insurance-${index}`,
        critical: item.percent >= CRITICAL_PERCENT,
        percentLabel: formatPercent(item.percent),
        width: `${Math.min(Math.max(item.percent, 2), 100)}%`,
        to: glossInsuranceRoute(item, this.filter),
      }));
    },
  },
};
</script>
